<template>
  <div class="shop-form__block" v-if="currentLoyalityKind === 'certificate'">
    <div class="shop-form__head">
      {{
        currentSortedItemByCertificate.title === "Номинал"
          ? ""
          : currentSortedItemByCertificate.title
      }}
    </div>
    <div class="shop-form__table">
      <span
        class="button grey"
        v-for="time in currentSortedItemByCertificate.minutesArray"
        :class="{
          active: currentCertificateData.seanceLength === time,
        }"
        @click="currentCertificateData.seanceLength = time"
        :key="time"
        >{{ time }}</span
      >
    </div>
  </div>
  <div class="shop-form__block" v-if="currentLoyalityKind === 'abonement'">
    <div class="shop-form__head">
      {{ currentSortedItemByAbonement.title }}
    </div>
    <div class="shop-form__table">
      <span
        class="button grey"
        :class="{
          active: currentAbonementData.seanceLength === time,
        }"
        v-for="time in currentSortedItemByAbonement.minutesArray"
        @click="currentAbonementData.seanceLength = time"
        :key="time"
        >{{ time }}</span
      >
    </div>
  </div>
  <div class="quantity" v-if="currentLoyalityKind === 'abonement'">
    <div class="shop-form__title">Количество</div>
    <span
      class="button grey"
      v-for="seat in currentSortedItemByAbonement.balancesArray"
      :class="{
        active: currentAbonementData.seats === seat,
      }"
      @click="currentAbonementData.seats = seat"
      :key="seat"
      >{{ seat }}</span
    >
  </div>
</template>

<script lang="ts" setup>
import { computed, watch } from "vue";
import { useStore } from "vuex";
import { TypeLoyalityKinds, TypeLoyaliyMainName } from "@/types";
import {TypeAbonementObj, TypeCertificateObj} from '@/types/typesOfApi'
import {
  IloyalityShopData,
  TypeReceiver,
  TypeSortedLoyalityByName,
  IbyCertificate,
  IbyAbonement,
} from "@/types/typesOfState";
import { Store } from "vuex";

const store = useStore();

const loyalityShopData = computed<IloyalityShopData>(
  () => store.state.loyalityShopData
);
const currentLoyalityKind = computed<TypeLoyalityKinds>(
  () => store.state.currentLoyalityKind
);

const sortedLoyalityByName = computed<TypeSortedLoyalityByName>(
  () => store.state.sortedLoyalityByName
);

const currentCertificateData = computed<IbyCertificate>(
  () => store.state.loyalityShopData.byCertificate
);
const currentSortedItemByCertificate = computed<TypeLoyaliyMainName>(
  () =>
    store.state.sortedLoyalityByName.certificates[
      currentCertificateData.value.name || ""
    ]
);
const currentAbonementData = computed<IbyAbonement>(
  () => store.state.loyalityShopData.byAbonement
);
const currentSortedItemByAbonement = computed<TypeLoyaliyMainName>(
  () =>
    store.state.sortedLoyalityByName.abonements[
      currentAbonementData.value.name || ""
    ]
);

function setLoyality(loyalityName: string): void {
  if (currentLoyalityKind.value === "certificate") {
    store.state.loyalityShopData.byCertificate.name = loyalityName;
  } else {
    store.state.loyalityShopData.byAbonement.name = loyalityName;
  }
}

watch(
  currentAbonementData,
  (value: IbyAbonement) => {
    console.log(value);

    if (
      value.seanceLength &&
      value.seats
    ) {
      const currentAbonements:TypeAbonementObj[]= currentSortedItemByAbonement.value.list;

      const currentAbonement:TypeAbonementObj | undefined = currentAbonements.find((i: TypeAbonementObj) => {
        const currentRegExpText = `${value.seanceLength}\\s*(минут)?`;
        const currentRegExp = new RegExp(currentRegExpText, "i");
        return (
          i.united_balance_services_count === value.seats &&
          currentRegExp.test(i.title)
        );
      });

      const currentAbonementId = currentAbonement?.id;

      store.state.loyalityShopData.buyLoyalityType = currentAbonementId;
    }
  },
  { deep: true }
);
watch(
  currentCertificateData,
  (value: IbyCertificate) => {
    console.log(value);

    if (value.seanceLength) {
      const currentCertificates:TypeCertificateObj[] = currentSortedItemByCertificate.value.list;

      const currentCertificate: TypeCertificateObj | undefined = currentCertificates.find((i: TypeCertificateObj) => {
        const currentRegExpText = `${value.seanceLength}\\s*(минут)?`;
        const currentRegExp = new RegExp(currentRegExpText, "i");
        return currentRegExp.test(i.title);
      });

      const currentcertificateId = currentCertificate?.id;

      store.state.loyalityShopData.buyLoyalityType = currentcertificateId;
    }
  },
  { deep: true }
);
</script>

<style></style>
